<script setup lang="ts">
import { useAuth } from '~/composables/useAuth';
import { useDealerContent } from '~/composables/useDealerContent';
import siteSettings from '~/server/api/site-settings';
import { type AllResponse } from '~/server/types';

const { data, error } = await useFetch('/api/site-settings', {});

const { monitorSession } = useAuth();
monitorSession();

const { fetchDealerContent } = useDealerContent();
onMounted(() => {
  fetchDealerContent();
});

// ☝️ we fetch these in the layout to avoid fetching them in every page.
// also, we can just inject on future page types if we so desire.
const { data: siteWideComponents } = await useFetch<AllResponse>('/api/content/all?filter=contentType:siteSettings', {
  key: `siteWideComponentsFetched`,
  cache: false
});

const components = siteWideComponents.value?.properties?.components ?? null;

provide('siteWideComponents', components);
provide('siteSettings', data.value);
</script>

<template>
  <NuxtLoadingIndicator :height="10" color="#ED8B00" />
  <div class="flex min-h-screen flex-col justify-center">
    <NavigationHeader :primary-navigation="data?.primaryNavigation" />
    <main class="flex flex-grow flex-col">
      <slot />
    </main>
    <LazyNavigationFooter v-bind="data?.footerNavigation" />
  </div>
</template>
